import request from 'ykd-base/request'
import PartnerData from '@/model/coupon/partnerData'
import CouponDefine from '@/model/coupon/couponDefine'

export async function searchProfileInfo(
  keyword: string
): Promise<PartnerData[]> {
  const res = await request<PartnerData[]>({
    method: 'GET',
    biz: 'done',
    url: '/coupondefine/search',
    params: {
      keyword: keyword
    }
  })
  return res && res.data
}
export async function getCouponDefine(id: string): Promise<CouponDefine> {
  const res = await request<CouponDefine>({
    method: 'GET',
    biz: 'done',
    url: `/coupondefine/get?id=${id}`,
   
  })
  return res && res.data
}
